// ── Imports ───────────────────────────────────────────────────────────────────
import BWillisDashboard  from "views/bwillis/Dashboard/BWillisDashboard.jsx";
import StudentList       from "views/bwillis/Students/StudentList.jsx";
import StudentForm       from "views/bwillis/Students/StudentForm.jsx";
import StudentProfile    from "views/bwillis/Students/StudentProfile.jsx";
import BiodataAppeals    from "views/bwillis/Students/BiodataAppeals.jsx";
import ApplicationList   from "views/bwillis/Admissions/ApplicationList.jsx";
import ProgrammeList     from "views/bwillis/Academic/ProgrammeList.jsx";
import CourseList        from "views/bwillis/Academic/CourseList.jsx";
import SemesterList      from "views/bwillis/Academic/SemesterList.jsx";
import DepartmentList    from "views/bwillis/Departments/DepartmentList.jsx";
import DepartmentProfile from "views/bwillis/Departments/DepartmentProfile.jsx";
import CurriculumMap     from "views/bwillis/Curriculum/CurriculumMap.jsx";
import ClassTimetable    from "views/bwillis/Timetable/ClassTimetable.jsx";
import TimetableBuilder  from "views/bwillis/Timetable/TimetableBuilder.jsx";
import EnrollmentList    from "views/bwillis/Enrollment/EnrollmentList.jsx";
import ExamSchedule      from "views/bwillis/Exams/ExamSchedule.jsx";
import CourseworkMarks   from "views/bwillis/Results/CourseworkMarks.jsx";
import ExamResults       from "views/bwillis/Results/ExamResults.jsx";
import Transcript        from "views/bwillis/Results/Transcript.jsx";
import ClearanceList     from "views/bwillis/Clearance/ClearanceList.jsx";
import LibraryCatalogue  from "views/bwillis/Library/LibraryCatalogue.jsx";
import LibraryIssues     from "views/bwillis/Library/LibraryIssues.jsx";
import FeeStructure      from "views/bwillis/Fees/FeeStructure.jsx";
import PaymentList       from "views/bwillis/Fees/PaymentList.jsx";
import ArrearsReport     from "views/bwillis/Fees/ArrearsReport.jsx";
import BudgetDetails     from "views/bwillis/Finance/BudgetDetails.jsx";
import ExpenditureList   from "views/bwillis/Finance/ExpenditureList.jsx";
import LecturerList      from "views/bwillis/Lecturer/LecturerList.jsx";
import LecturerCourses   from "views/bwillis/Lecturer/LecturerCourses.jsx";
import StaffList         from "views/bwillis/HR/StaffList.jsx";
import LeaveList         from "views/bwillis/HR/LeaveList.jsx";
import PayrollList       from "views/bwillis/HR/PayrollList.jsx";
import RecruitmentList   from "views/bwillis/HR/RecruitmentList.jsx";
import StaffEvaluation   from "views/bwillis/HR/StaffEvaluation.jsx";
import StaffExit         from "views/bwillis/HR/StaffExit.jsx";
import PurchaseOrders    from "views/bwillis/Procurement/PurchaseOrders.jsx";
import Suppliers         from "views/bwillis/Procurement/Suppliers.jsx";
import InventoryList     from "views/bwillis/Inventory/InventoryList.jsx";
import AssetList         from "views/bwillis/Assets/AssetList.jsx";
import GuildManagement   from "views/bwillis/Guild/GuildManagement.jsx";
import MealManagement    from "views/bwillis/Catering/MealManagement.jsx";
import AlumniList        from "views/bwillis/Alumni/AlumniList.jsx";
import AlumniActivities  from "views/bwillis/Alumni/AlumniActivities.jsx";
import NoticeBoard       from "views/bwillis/Communications/NoticeBoard.jsx";
import Announcements     from "views/bwillis/Communications/Announcements.jsx";
import UserList           from "views/bwillis/Administration/UserList.jsx";
import PermissionsMgt    from "views/bwillis/Permissions/PermissionsMgt.jsx";
import Reports           from "views/bwillis/Reports/Reports.jsx";
import AuditLog          from "views/bwillis/Audit/AuditLog.jsx";

// ── Icons ─────────────────────────────────────────────────────────────────────
import DashboardIcon      from "@material-ui/icons/Dashboard";
import PeopleIcon         from "@material-ui/icons/People";
import SchoolIcon         from "@material-ui/icons/School";
import EventNoteIcon      from "@material-ui/icons/EventNote";
import AssignmentIcon     from "@material-ui/icons/Assignment";
import LibraryBooksIcon   from "@material-ui/icons/LibraryBooks";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import WorkIcon           from "@material-ui/icons/Work";
import ShoppingCartIcon   from "@material-ui/icons/ShoppingCart";
import GroupIcon          from "@material-ui/icons/Group";
import AnnouncementIcon   from "@material-ui/icons/Announcement";
import SecurityIcon       from "@material-ui/icons/Security";

// ── Route table ───────────────────────────────────────────────────────────────
var bwillisRoutes = [

  // ── Dashboard ────────────────────────────────────────────────────────────
  {
    path: "/bwillis/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: BWillisDashboard,
    roles: ["*"]
  },

  // ── STUDENTS ─────────────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/students-menu",
    name: "Students",
    icon: PeopleIcon,
    state: "openStudents",
    roles: ["Principal", "Registrar", "Dean of Studies", "Administrator"],
    views: [
      { path: "/bwillis/admissions", name: "Admissions", mini: "AD", component: ApplicationList },
      { path: "/bwillis/students",   name: "Students",   mini: "ST", component: StudentList     },
      { path: "/bwillis/biodata-appeals", name: "Biodata Appeals", mini: "BA", component: BiodataAppeals }
    ]
  },

  // ── ACADEMICS ────────────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/academics",
    name: "Academics",
    icon: SchoolIcon,
    state: "openAcademics",
    roles: ["Principal", "Registrar", "Dean of Studies", "Administrator"],
    views: [
      { path: "/bwillis/academic/departments", name: "Departments", mini: "DP", component: DepartmentList },
      { path: "/bwillis/academic/programmes",  name: "Programmes",  mini: "PG", component: ProgrammeList  },
      { path: "/bwillis/academic/courses",     name: "Courses",     mini: "CO", component: CourseList     },
      { path: "/bwillis/academic/semesters",   name: "Semesters",   mini: "SM", component: SemesterList   },
      { path: "/bwillis/curriculum",           name: "Curriculum",  mini: "CU", component: CurriculumMap  }
    ]
  },

  // ── TIMETABLE ────────────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/timetable-menu",
    name: "Timetable",
    icon: EventNoteIcon,
    state: "openTimetable",
    roles: ["Principal", "Registrar", "Dean of Studies", "Lecturer", "Administrator"],
    views: [
      { path: "/bwillis/timetable",        name: "Class Timetable",  mini: "CT", component: ClassTimetable  },
      { path: "/bwillis/timetable/manage", name: "Manage Timetable", mini: "MT", component: TimetableBuilder }
    ]
  },

  // ── ASSESSMENTS & RESULTS ────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/assessments",
    name: "Assessments",
    icon: AssignmentIcon,
    state: "openAssessments",
    roles: ["Principal", "Registrar", "Dean of Studies", "Lecturer", "Administrator"],
    views: [
      { path: "/bwillis/enrollment",        name: "Enrollment",    mini: "EN", component: EnrollmentList  },
      { path: "/bwillis/exams/schedule",    name: "Exam Schedule", mini: "ES", component: ExamSchedule    },
      { path: "/bwillis/results/coursework",name: "Coursework",    mini: "CW", component: CourseworkMarks },
      { path: "/bwillis/results/exams",     name: "Exam Results",  mini: "ER", component: ExamResults     },
      { path: "/bwillis/results/transcript",name: "Transcripts",   mini: "TR", component: Transcript      },
      { path: "/bwillis/clearance",         name: "Clearance",     mini: "CL", component: ClearanceList   }
    ]
  },

  // ── LIBRARY ──────────────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/library",
    name: "Library",
    icon: LibraryBooksIcon,
    state: "openLibrary",
    roles: ["Principal", "Librarian", "Registrar", "Lecturer", "Dean of Studies"],
    views: [
      { path: "/bwillis/library/catalogue", name: "Catalogue",       mini: "CA", component: LibraryCatalogue },
      { path: "/bwillis/library/issues",    name: "Issues & Returns", mini: "IR", component: LibraryIssues    }
    ]
  },

  // ── FINANCE ──────────────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/financials",
    name: "Finance",
    icon: AccountBalanceIcon,
    state: "openFinancials",
    roles: ["Principal", "Bursar", "Registrar"],
    views: [
      { path: "/bwillis/fees/structure",    name: "Fee Structure",  mini: "FS", component: FeeStructure   },
      { path: "/bwillis/fees/payments",     name: "Payments",       mini: "PM", component: PaymentList    },
      { path: "/bwillis/fees/arrears",      name: "Arrears",        mini: "AR", component: ArrearsReport  },
      { path: "/bwillis/finance/budget",    name: "Budget",         mini: "BD", component: BudgetDetails  },
      { path: "/bwillis/finance/expenditure",name: "Expenditure",   mini: "EX", component: ExpenditureList}
    ]
  },

  // ── HUMAN RESOURCE ───────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/human-resource",
    name: "Human Resource",
    icon: WorkIcon,
    state: "openHumanResource",
    roles: ["Principal", "Administrator", "Registrar"],
    views: [
      { path: "/bwillis/lecturers",      name: "Lecturers",     mini: "LC", component: LecturerList    },
      { path: "/bwillis/hr/staff",       name: "Staff Records", mini: "SR", component: StaffList        },
      { path: "/bwillis/hr/leave",       name: "Leave",         mini: "LV", component: LeaveList        },
      { path: "/bwillis/hr/payroll",     name: "Payroll",       mini: "PR", component: PayrollList      },
      { path: "/bwillis/hr/recruitment", name: "Recruitment",   mini: "RC", component: RecruitmentList  },
      { path: "/bwillis/hr/evaluation",  name: "Evaluation",    mini: "EV", component: StaffEvaluation  },
      { path: "/bwillis/hr/exit",        name: "Staff Exit",    mini: "SE", component: StaffExit        }
    ]
  },

  // ── PROCUREMENT & ASSETS ─────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/procurement",
    name: "Procurement",
    icon: ShoppingCartIcon,
    state: "openProcurement",
    roles: ["Principal", "Administrator", "Bursar"],
    views: [
      { path: "/bwillis/procurement/orders",    name: "Purchase Orders", mini: "PO", component: PurchaseOrders },
      { path: "/bwillis/procurement/suppliers", name: "Suppliers",       mini: "SP", component: Suppliers      },
      { path: "/bwillis/inventory",             name: "Inventory",       mini: "IN", component: InventoryList  },
      { path: "/bwillis/assets",                name: "Assets",          mini: "AS", component: AssetList      }
    ]
  },

  // ── STUDENT AFFAIRS ──────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/student-affairs",
    name: "Student Affairs",
    icon: GroupIcon,
    state: "openStudentAffairs",
    roles: ["Principal", "Registrar", "Dean of Studies", "Administrator"],
    views: [
      { path: "/bwillis/guild",             name: "Guild / Council",   mini: "GC", component: GuildManagement  },
      { path: "/bwillis/catering",          name: "Catering",          mini: "CA", component: MealManagement   },
      { path: "/bwillis/alumni",            name: "Alumni Database",   mini: "AD", component: AlumniList       },
      { path: "/bwillis/alumni/activities", name: "Alumni Activities", mini: "AA", component: AlumniActivities }
    ]
  },

  // ── COMMUNICATIONS ───────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/communications",
    name: "Communications",
    icon: AnnouncementIcon,
    state: "openComms",
    roles: ["*"],
    views: [
      { path: "/bwillis/communications",               name: "Notice Board",  mini: "NB", component: NoticeBoard  },
      { path: "/bwillis/communications/announcements", name: "Announcements", mini: "AN", component: Announcements }
    ]
  },

  // ── ADMINISTRATION ───────────────────────────────────────────────────────
  {
    collapse: true,
    path: "/bwillis/admin",
    name: "Administration",
    icon: SecurityIcon,
    state: "openAdmin",
    roles: ["Principal", "Administrator"],
    views: [
      { path: "/bwillis/users",       name: "Users",       mini: "US", component: UserList       },
      { path: "/bwillis/permissions", name: "Permissions", mini: "PM", component: PermissionsMgt },
      { path: "/bwillis/reports",     name: "Reports",     mini: "RP", component: Reports        },
      { path: "/bwillis/audit",       name: "Audit Log",   mini: "AU", component: AuditLog       }
    ]
  },

  // ── Hidden dynamic routes (routing only — not in sidebar) ─────────────────
  { hidden: true, path: "/bwillis/students/new",           component: StudentForm      },
  { hidden: true, path: "/bwillis/students/:id/edit",      component: StudentForm      },
  { hidden: true, path: "/bwillis/students/:id",           component: StudentProfile   },
  { hidden: true, path: "/bwillis/academic/departments/:id", component: DepartmentProfile },
  { hidden: true, path: "/bwillis/lecturers/:id/courses",  component: LecturerCourses  },

  // ── Redirect ─────────────────────────────────────────────────────────────
  { redirect: true, path: "/bwillis", pathTo: "/bwillis/dashboard", name: "Dashboard" }
];

export default bwillisRoutes;
